export default {
  setExpenseList({ commit }, payload) {
    commit('SET_EXPENSE_LIST', payload);
  },
};
